module.exports = __webpack_public_path__ + "static/media/bluezones_logo_only.db1c55cf.png";